import {Marker}  from "@react-google-maps/api";

import { getPlaceImage } from './lib/placeImage';

const Pin = ({ title, description, lat, lng, thumb,place_id, source_id, sourceKey, canonicalurl, setPlace, setViewInfoOpen, walkStageNumber }) => {
  const place = {
    title,
    description,
    thumb, place_id, source_id, sourceKey, canonicalurl, lat,lng, walkStageNumber
  };
  const image = getPlaceImage(thumb, sourceKey);
  const icon = {
    url: image.url, // url
    scaledSize: new window.google.maps.Size(50, 50), // scaled size
    origin: new window.google.maps.Point(0,0), // origin
    anchor: new window.google.maps.Point(0,0), // anchor
};
  if (walkStageNumber === 0 ){
    return (
      <Marker 
        className= "Map-pin"
        onClick={ evt => { setViewInfoOpen(true); setPlace(place) } }
        position={{        lat: lat,        lng: lng,}} 
        icon={icon}
        title={title}
        />
    );
  } else {
    return (
      <Marker 
        className= "Map-pin"
        onClick={ evt => { setViewInfoOpen(true); setPlace(place) } }
        position={{        lat: lat,        lng: lng,}} 
        icon={icon}
        label={walkStageNumber}
        title={title}
        />
    );
  }
};

export default Pin;
